module.exports = __webpack_public_path__ + "media/images/moving_truck_icon_active-f81eea1a.svg";